module.exports = __webpack_public_path__ + "img/WxQRCode.19186ece.jpeg";